import clsx from 'clsx';
import { kebabCase } from 'lodash';
import React from 'react';

import { topic_landing_path } from '@routes';
import { encodeEntity } from '@utils/formatting';

import styles from './styles.module.scss';

export default function TopicPill({ className, topic }: { className?: string; topic: string }) {
  return (
    <a
      className={clsx('track-click quiet-link', className, styles.topicPill)}
      href={topic_landing_path(encodeEntity(topic))}
      data-name={`topic badge: ${kebabCase(topic)}`}
      data-type="link"
    >
      {topic}
    </a>
  );
}
